<template>
   <transition name="fade">
    <div id="goTop" v-show="goTopShow">
      <span @click="goTop" class="toTop"><el-icon class="top" style="font-size: 20px;"><Top /></el-icon></span>
    </div>
  </transition>
  </template>
  
  <script>
    export default {
      name: "backTop",
      data() {
        return {
          scrollTop: '',
          goTopShow: false,
        }
      },
      created() {
      },
      methods: {
        handleScroll() {
          this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if (this.scrollTop > 1000) {//设置页面滑动多少显示按钮
            this.goTopShow = true
          } else {
            this.goTopShow = false;
          }
        },
        goTop() {
          let timer = null;
          cancelAnimationFrame(timer)
          timer = requestAnimationFrame(() => {
            const fn = () => {
              if (this.scrollTop > 0) {
                this.scrollTop -= 60;//回到顶部的速度
                document.body.scrollTop = document.documentElement.scrollTop = this.scrollTop;
                timer = requestAnimationFrame(fn)
              } else {
                cancelAnimationFrame(timer);
                this.goTopShow = false;
              }
            }
            fn()
          })
        }
      },
      mounted() {
        window.addEventListener('scroll', this.handleScroll);
      },
      unmounted() {
        window.removeEventListener('scroll', this.handleScroll)
      }
    }
  </script>
  
  <style scoped>
    .goTop:hover {
      background: rgba(0, 0, 0, 1);
    }
    .toTop {
      display: inline-block;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: #fff;
      opacity: .9;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
      position: fixed;
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 40px;
      right: 30px;
      color: #409eff;
      font-size: 20px;
      cursor: pointer;
      z-index: 99;
      transition: opacity 1s;
      animation: rise 2s forwards; /* 弹跳动画播放时间2秒，重复3次；升起动画播放时间2秒，保持最后状态 */
    }
    @keyframes rise {
      0% {
        bottom: 0;
      }
      100% {
        bottom: 40px;
      }
    }
    .top{
        transition: transform 0.5s;
    }
    .top:hover{
        transform: rotate(360deg);
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
      }
      .fade-enter, .fade-leave-to {
        opacity: 0;
      }
  </style>
  
  